var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.componentPriceName,{tag:"component",attrs:{"show-header":_vm.showHeader,"show-footer":_vm.showFooter,"promotions":_vm.promotions,"total-amount":_vm.totalAmount,"product":_vm.product}})
}
var staticRenderFns = []

export { render, staticRenderFns }